import client from "@/services/rest/client.js"

// Get all responsible gambling limits for the user
export function getSessionLimits() {
    const method = "get"
    const url = "/public/player/responsible-gambling"
    return client({ method, url })
}

// Save (create or update) a responsible gambling limit
export function saveSessionLimit(data) {
    const method = "post"
    const url = "/public/player/responsible-gambling"
    return client({ method, url, data })
}

// Delete a responsible gambling limit
export function deleteSessionLimit(limitId) {
    const method = "delete"
    const url = `/public/player/responsible-gambling/${limitId}`
    return client({ method, url })
}

// Alias functions for better naming consistency
export const getResponsibleGamblingLimits = getSessionLimits
export const saveResponsibleGamblingLimit = saveSessionLimit
export const deleteResponsibleGamblingLimit = deleteSessionLimit
